import { render, staticRenderFns } from "./plan-card-add-to-cart-button.vue?vue&type=template&id=0d3b8a5e&"
import script from "./plan-card-add-to-cart-button.vue?vue&type=script&setup=true&lang=js&"
export * from "./plan-card-add-to-cart-button.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports